import { Box, Button, Stack, Typography } from '@mui/material'
import { ReactNode } from 'react'

type ProductPromoCardProps = {
  icon: ReactNode
  title: string
  description: string
  primaryLabel: string
  primaryHref: string
  secondaryLabel?: string
  secondaryHref?: string
}

export function ProductPromoCard({
  icon,
  title,
  description,
  primaryLabel,
  primaryHref,
  secondaryLabel,
  secondaryHref,
}: ProductPromoCardProps) {
  return (
    <Box
      sx={{
        bgcolor: 'productSwitcher.front',
        color: 'background.paper',
        borderRadius: 2,
        p: 2,
      }}
    >
      <Stack direction="row" spacing={1.5} alignItems="flex-start">
        <Box
          sx={{
            width: 36,
            height: 36,
            borderRadius: '50%',
            display: 'grid',
            placeItems: 'center',
            bgcolor: 'productSwitcher.back',
            color: 'productSwitcher.front',
            fontSize: 16,
            flexShrink: 0,
          }}
        >
          {icon}
        </Box>
        <Box>
          <Typography fontWeight={700}>{title}</Typography>
          <Typography variant="body2" sx={{ opacity: 0.9 }}>
            {description}
          </Typography>
        </Box>
      </Stack>
      <Stack direction="row" spacing={1} mt={2}>
        <Button
          size="small"
          href={primaryHref}
          target="_blank"
          rel="noopener noreferrer"
          sx={{ bgcolor: 'background.paper', color: 'productSwitcher.front' }}
        >
          {primaryLabel}
        </Button>
        {secondaryLabel && secondaryHref && (
          <Button
            size="small"
            variant="text"
            href={secondaryHref}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: 'background.paper' }}
          >
            {secondaryLabel}
          </Button>
        )}
      </Stack>
    </Box>
  )
}
